import { render, staticRenderFns } from "./person_policy.vue?vue&type=template&id=3cfd9db4&scoped=true&"
import script from "./person_policy.vue?vue&type=script&lang=js&"
export * from "./person_policy.vue?vue&type=script&lang=js&"
import style0 from "./person_policy.vue?vue&type=style&index=0&id=3cfd9db4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfd9db4",
  null
  
)

export default component.exports